import { createContext, useContext } from "react";
import { fetchSupportedLocales } from "./fetchSupportedLocales";
import validateAndFormatLocale from "./validateAndFormatLocale.ts";

// All data required for the app to initialize
export type LocaleConfig = {
  locales: ReadonlyArray<string>;
  defaultLocale: string;
  currentLocale: string;
};

export type GlobalContextType = {
  localeConfig: LocaleConfig;
  previewContent: boolean;
};

export const GlobalContext = createContext<null | GlobalContextType>(null);

export const useGlobalContext = () => {
  const globalContext = useContext(GlobalContext);
  if (!globalContext) {
    throw new Error("GlobalContext data has not been provided.");
  }

  return globalContext;
};

export const fetchInitialGlobalContext =
  async (): Promise<GlobalContextType> => {
    const { defaultLocale, locales } = await fetchSupportedLocales();
    // Get current locale from URL path
    const currentLocale = validateAndFormatLocale(
      window.location.pathname.split("/")[1] || defaultLocale,
      locales,
    );

    return {
      // TODO: Add preview content
      previewContent: false,
      localeConfig: {
        // TODO update locale on route change
        currentLocale: currentLocale ?? defaultLocale,
        defaultLocale,
        locales,
      },
    };
  };
